import React, { useCallback, FC } from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';

export interface IButton {
  className?: string;
  disabled?: boolean;
  form?: string;
  icon?: JSX.Element;
  link?: string;
  router?: boolean;
  target?: string;
  text?: string;
  title?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'transparent' | 'submit' | 'icon' | 'link' | 'danger' | 'warning' | 'no-borders';
  onClick?: () => void;
}

const Button: FC<IButton> = ({
  className = '',
  disabled,
  icon,
  link,
  router = false,
  text = '',
  type = 'button',
  variant = 'primary',
  onClick,
  ...props
}) => {
  const classList = `hbh-btn ${disabled ? 'hbh-btn-disabled ' : ''}${variant && `hbh-btn-${variant}`} ${className}`;

  const handleClick = useCallback(() => onClick?.(), [onClick]);

  const LinkElement = (): JSX.Element => {
    const content = (
      <>
        {icon ? <span className={text.length ? 'icon' : undefined}>{icon}</span> : null}
        {text}
      </>
    );
    return router ? (
      <Link className={classList} to={link ? link : ''} {...props}>
        {content}
      </Link>
    ) : (
      <a className={classList} href={link} rel='noreferrer' {...props}>
        {content}
      </a>
    );
  };

  return (
    <>
      {link ? (
        <LinkElement />
      ) : (
        <button className={classList} onClick={handleClick} type={type} disabled={disabled} {...props}>
          {icon ? <span className={text.length ? 'icon' : undefined}>{icon}</span> : null}
          {text}
        </button>
      )}
    </>
  );
};

export default Button;
